import { useRef, useState } from "react";

import { Raster } from "@nens/lizard/api-v4";

export function useRasterAnimation(raster: Raster | null) {
  let startMs = -1;
  let endMs = -1;
  if (raster !== null && raster.temporal) {
    const { first_value_timestamp, last_value_timestamp } = raster;

    startMs = first_value_timestamp?.getTime() ?? -1;
    endMs = last_value_timestamp?.getTime() ?? -1;
  }

  const valid = raster && raster.temporal && startMs >= 0 && endMs >= 0 && endMs > startMs;

  const [animating, setAnimating] = useState(true);
  const [currentTime, actualSetCurrentTime] = useState(startMs);
  const [waiting, setWaiting] = useState(true);

  const setCurrentTime = (time: number) => {
    console.log("in setCurrentTime", time);
    if (startMs <= time && time <= endMs) {
      console.log("setting setCurrentTime", time);
      actualSetCurrentTime(time);
    }
  };

  const start = () => {
    if (!animating) {
      setAnimating(true);
    }
  };

  const stop = () => {
    if (animating) {
      setAnimating(false);
    }
  };

  const rasterRef = useRef<Raster | null>(raster);

  if (rasterRef.current?.uuid !== raster?.uuid) {
    // We switched to another raster. Stop animating. Also assume we're waiting.
    if (animating) {
      setAnimating(false);
      setWaiting(true);
    }
    // If current time is not within the new start and end, reset it.
    if (!(startMs <= currentTime && currentTime <= endMs)) {
      actualSetCurrentTime(startMs);
    }

    rasterRef.current = raster;
  }

  return valid
    ? {
        valid: true as const,
        startMs,
        endMs,
        currentTime,
        setCurrentTime,
        waiting,
        setWaiting,
        animating,
        start,
        stop,
      }
    : {
        valid: false as const,
      };
}
